/**
 * Returns true if the error code is invalid for Sentry
 */
const isInvalidSentryGqlCode = (code: string | null) => {
  if (!code) {
    return false;
  }

  // PERIOD_CLOSED is an expected refusal of edits inside closed books
  const disallowedCodes = [
    "UNAUTHENTICATED",
    "404",
    "BAD_USER_INPUT",
    "PERIOD_CLOSED",
  ];

  return disallowedCodes.includes(code);
};

export default isInvalidSentryGqlCode;
